// @ts-strict-ignore
import { combineReducers } from 'redux';
import { TryUpdateStepConfigsAction, UPDATE_STEP_CONFIGS } from '@/actions/stepConfig';
import { StepConfig } from '@/types/stepConfig';

interface StepConfigsById {
    [id: string]: StepConfig;
}

type StepConfigActionTypes = TryUpdateStepConfigsAction;

function stepConfigsById(state: StepConfigsById = {}, action: StepConfigActionTypes) {
    switch (action.type) {
        case UPDATE_STEP_CONFIGS: {
            const newState = {
                ...state,
            };
            const stepConfigs = action.payload;
            for (const stepConfig of stepConfigs) {
                newState[stepConfig.id] = stepConfig;
            }
            return newState;
        }
        default:
            return state;
    }
}

export const stepConfigsReducer = combineReducers({
    byId: stepConfigsById,
});
